(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sticker"] && !Shopify.designMode) return;
  try {
    
(function () {
  const instances = new Map();

  function initialize(root) {
    if (instances.has(root)) return;

    const wrap = root.querySelector('.dfs-sticker');
    const ring = root.querySelector('.dfs-sticker--circle .sticker');
    const image = root.querySelector('.dfs-sticker--circle .submark img');
    const trigger = root.querySelector('.dfs-sticker-trigger');
    const modal = root.querySelector('.dfs-modal');
    const panel = modal?.querySelector('.dfs-modal__panel');

    const controller = new AbortController();
    const signal = controller.signal;

    let destroyed = false;
    let frame = 0;
    let observer = null;
    let lastFocused = null;

    function listen(target, event, handler) {
      if (target) {
        target.addEventListener(event, handler, { signal });
      }
    }

    /* ========================
       Popup
    ======================== */

    function focusableElements() {
      if (!modal) return [];

      return Array.from(
        modal.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), ' +
          'select:not([disabled]), textarea:not([disabled]), ' +
          '[tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (element) {
        return element.tabIndex >= 0 && element.getClientRects().length > 0;
      });
    }

    function openModal(event) {
      if (event) event.preventDefault();
      if (!modal || modal.classList.contains('is-open')) return;

      lastFocused = document.activeElement;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }

      if (panel) {
        panel.focus({ preventScroll: true });
      }
    }

    function closeModal(restoreFocus = true) {
      if (!modal || !modal.classList.contains('is-open')) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (restoreFocus) {
        const target = lastFocused?.isConnected ? lastFocused : trigger;

        if (target?.isConnected) {
          target.focus({ preventScroll: true });
        }
      }
    }

    function handleModalKey(event) {
      if (!modal?.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const elements = focusableElements();
      const first = elements[0];
      const last = elements[elements.length - 1];
      const active = document.activeElement;

      if (!elements.length) {
        event.preventDefault();
        panel?.focus();
        return;
      }

      if (event.shiftKey && (active === first || !elements.includes(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !elements.includes(active))) {
        event.preventDefault();
        first.focus();
      }
    }

    if (trigger && modal) {
      listen(trigger, 'click', openModal);

      modal.querySelectorAll('[data-close]').forEach(function (element) {
        listen(element, 'click', function (event) {
          event.preventDefault();
          closeModal();
        });
      });

      listen(document, 'keydown', handleModalKey);
    }

    /* ========================
       Circular text
    ======================== */

    function cssNumber(name, fallback) {
      const value = parseFloat(
        getComputedStyle(wrap).getPropertyValue(name)
      );

      return Number.isFinite(value) ? value : fallback;
    }

    function scheduleBuild() {
      if (destroyed || !ring || !image) return;

      cancelAnimationFrame(frame);

      frame = requestAnimationFrame(function () {
        frame = 0;
        build();
      });
    }

    function build() {
      if (destroyed || !wrap || !ring || !image || !root.isConnected) return;

      const rawText = ring.getAttribute('data-raw') || '';
      if (!rawText) return;

      const imageWidth = image.getBoundingClientRect().width;

      /* Wait for an image load or resize instead of retrying endlessly. */
      if (!imageWidth) return;

      /*
       * Measure a span inside the ring so the existing span CSS
       * supplies the actual font family and desktop/mobile size.
       */
      const probe = document.createElement('span');
      probe.textContent = 'M';

      Object.assign(probe.style, {
        visibility: 'hidden',
        pointerEvents: 'none',
        transform: 'none',
        transition: 'none',
        letterSpacing: '0px',
        fontKerning: 'none',
        fontVariantLigatures: 'none'
      });

      ring.appendChild(probe);

      const style = getComputedStyle(probe);
      const transform = style.textTransform;

      const font = [
        style.fontStyle || 'normal',
        style.fontWeight || '400',
        style.fontSize || '16px',
        style.fontFamily || 'sans-serif'
      ].join(' ');

      probe.remove();

      let text = rawText;

      if (transform === 'uppercase') {
        text = text.toUpperCase();
      } else if (transform === 'lowercase') {
        text = text.toLowerCase();
      }

      const chars =
        typeof Intl.Segmenter === 'function'
          ? Array.from(
              new Intl.Segmenter(undefined, {
                granularity: 'grapheme'
              }).segment(text),
              function (part) {
                return part.segment;
              }
            )
          : Array.from(text);

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (!context) return;

      context.font = font;

      if ('fontKerning' in context) {
        context.fontKerning = 'none';
      }

      /*
       * Use real character widths, including actual spaces.
       * Keep the original proportional full-circle distribution.
       */
      const tracking = cssNumber('--ring-tracking', 0);

      const widths = chars.map(function (character) {
        return Math.max(
          0.01,
          context.measureText(character).width + tracking
        );
      });

      const totalWidth = widths.reduce(function (sum, width) {
        return sum + width;
      }, 0);

      if (!totalWidth) return;

      const gap = cssNumber('--ring-gap', 12);
      const offset = cssNumber('--ring-offset', 2);
      const startDegrees = cssNumber('--ring-start-deg', -90);
      const direction = cssNumber('--ring-direction', 1) >= 0 ? 1 : -1;

      const radius = Math.max(1, imageWidth / 2 + gap + offset);
      const diameter = Math.ceil(radius * 2);

      wrap.style.setProperty('--ring-diameter', diameter + 'px');

      ring.style.width = diameter + 'px';
      ring.style.height = diameter + 'px';

      const fragment = document.createDocumentFragment();
      const startRadians = startDegrees * Math.PI / 180;

      let accumulated = 0;

      chars.forEach(function (character, index) {
        const sweep = widths[index] / totalWidth * Math.PI * 2;

        const middle =
          startRadians + direction * (accumulated + sweep / 2);

        const angle = middle * 180 / Math.PI;
        const span = document.createElement('span');

        span.textContent = character;
        span.setAttribute('aria-hidden', 'true');

        Object.assign(span.style, {
          letterSpacing: '0px',
          fontKerning: 'none',
          fontVariantLigatures: 'none',
          textTransform: 'none',
          transform:
            'rotate(' + angle + 'deg) ' +
            'translate(' + radius + 'px) ' +
            'rotate(' + (90 * direction) + 'deg) ' +
            'translate(-50%, -50%)'
        });

        fragment.appendChild(span);
        accumulated += sweep;
      });

      ring.setAttribute('role', 'img');
      ring.setAttribute('aria-label', text);
      ring.replaceChildren(fragment);
    }

    if (wrap && ring && image) {
      if (!ring.hasAttribute('data-raw')) {
        ring.setAttribute(
          'data-raw',
          (ring.textContent || '').trim()
        );
      }

      listen(image, 'load', scheduleBuild);
      listen(window, 'resize', scheduleBuild);

      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(scheduleBuild);
        observer.observe(image);
      }

      if (document.fonts) {
        document.fonts.ready.then(scheduleBuild);
        listen(document.fonts, 'loadingdone', scheduleBuild);
      }

      listen(document, 'df:rebuild-sticker', function (event) {
        const target = event.detail?.root;

        if (target && target !== root) return;

        scheduleBuild();
      });

      scheduleBuild();
    }

    /* ========================
       Cleanup
    ======================== */

    instances.set(root, function () {
      destroyed = true;

      closeModal(false);
      controller.abort();
      cancelAnimationFrame(frame);

      if (observer) {
        observer.disconnect();
      }

      instances.delete(root);
    });
  }

  function initializeWithin(container) {
    if (container.matches?.('[data-sticker-section]')) {
      initialize(container);
    }

    container.querySelectorAll('[data-sticker-section]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    }, { once: true });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (cleanup, root) {
      if (root === event.target || event.target.contains(root)) {
        cleanup();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
